import { Pipe, PipeTransform } from '@angular/core';
import { OrderType, PaymentType } from '../enums';

@Pipe({
    name: 'paymentTypeLabel',
    standalone: true,
    pure: true
})
export class PaymentTypeLabelPipe implements PipeTransform {
    transform(value: PaymentType, orderType?: OrderType | null): string {
        switch (value) {
            case PaymentType.Cash:
                return orderType === OrderType.Pickup ? 'payment_at_the_counter' : 'pay_at_store';
            case PaymentType.BankTransfer:
                return 'bank_transfer';
            case PaymentType.ZaloPay:
                return 'zalopay_payment_gateway';
            case PaymentType.Payon:
                return 'payon_payment_gateway';
            case PaymentType.Momo:
                return 'momo_payment_gateway';
            case PaymentType.Vnpay:
                return 'vnpay_payment_gateway';
            case PaymentType.PosappCard:
                return 'posapp_card_payment_gateway';
            default:
                return '';
        }
    }
}
